<form [formGroup]="invoiceFilterForm" (keydown.enter)="onEnterKey($event)">
	<div class="filters-scroll pe-1">
		<h6 class="mb-2">Terminy i opóźnienia</h6>
		<div class="row g-3">
			<mat-form-field appearance="outline" class="col-12 col-md-6">
				<mat-label>Data zapłaty</mat-label>
				<mat-date-range-input [rangePicker]="paymentTimePicker">
					<input matStartDate formControlName="paymentTimeFrom" placeholder="Od" />
					<input matEndDate formControlName="paymentTimeTo" placeholder="Do" />
				</mat-date-range-input>
				<mat-hint>DD.MM.YYYY - DD.MM.YYYY</mat-hint>
				<mat-datepicker-toggle matIconSuffix [for]="paymentTimePicker"></mat-datepicker-toggle>
				<mat-date-range-picker #paymentTimePicker></mat-date-range-picker>
			</mat-form-field>

			<mat-form-field appearance="outline" class="col-12 col-md-6">
				<mat-label>Termin płatności od daty korespondencji</mat-label>
				<mat-date-range-input [rangePicker]="paymentDeadlinePicker">
					<input matStartDate formControlName="paymentDeadlineFrom" placeholder="Od" />
					<input matEndDate formControlName="paymentDeadlineTo" placeholder="Do" />
				</mat-date-range-input>
				<mat-hint>DD.MM.YYYY - DD.MM.YYYY</mat-hint>
				<mat-datepicker-toggle matIconSuffix [for]="paymentDeadlinePicker"></mat-datepicker-toggle>
				<mat-date-range-picker #paymentDeadlinePicker></mat-date-range-picker>
			</mat-form-field>

			<mat-form-field appearance="outline" class="col-12 col-md-6">
				<mat-label>Data wystawienia</mat-label>
				<input matInput [matDatepicker]="issueDatePicker" formControlName="issueDate" />
				<mat-hint>DD.MM.YYYY</mat-hint>
				<mat-datepicker-toggle matIconSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #issueDatePicker></mat-datepicker>
			</mat-form-field>

			<mat-form-field appearance="outline" class="col-12 col-md-6">
				<mat-label>Deklarowany termin płatności</mat-label>
				<mat-date-range-input [rangePicker]="declaredPaymentDatePicker">
					<input matStartDate formControlName="declaredPaymentDateFrom" placeholder="Od" />
					<input matEndDate formControlName="declaredPaymentDateTo" placeholder="Do" />
				</mat-date-range-input>
				<mat-hint>DD.MM.YYYY - DD.MM.YYYY</mat-hint>
				<mat-datepicker-toggle matIconSuffix [for]="declaredPaymentDatePicker"></mat-datepicker-toggle>
				<mat-date-range-picker #declaredPaymentDatePicker></mat-date-range-picker>
			</mat-form-field>
		</div>

		<div class="row g-3 mt-0">
			<mat-form-field appearance="outline" class="col-12 col-md-3">
				<mat-label>Dni po terminie min</mat-label>
				<input matInput type="number" formControlName="daysAfterDeadlineMin" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-3">
				<mat-label>Dni po terminie max</mat-label>
				<input matInput type="number" formControlName="daysAfterDeadlineMax" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-3">
				<mat-label>Dni odroczenia min</mat-label>
				<input matInput type="number" formControlName="deferredPaymentDaysMin" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-3">
				<mat-label>Dni odroczenia max</mat-label>
				<input matInput type="number" formControlName="deferredPaymentDaysMax" />
			</mat-form-field>
		</div>

		<hr class="my-3" />
		<h6 class="mb-2">Kontrahent i dokument</h6>
		<div class="row g-3 mt-0">
			<div class="col-12 col-md-6 col-xl-3">
				<app-generic-mat-autocomplete
					[apiUrl]="contractorsApiUrl"
					[apiSearchParam]="'isOskar=false&search'"
					[placeholder]="'Kontrahent'"
					[idKey]="'id'"
					[displayKeys]="['shortName']"
					[responseMapper]="contractorsResponseMapper"
					(selected)="invoiceFilterForm.patchValue({ contractorId: $event?.id ?? null })"
				></app-generic-mat-autocomplete>
			</div>
			<div class="col-12 col-md-6 col-xl-3">
				<app-generic-mat-autocomplete
					[apiUrl]="contractorsApiUrl"
					[apiSearchParam]="'isOskar=true&search'"
					[placeholder]="'Sprzedawca'"
					[idKey]="'id'"
					[displayKeys]="['shortName']"
					[responseMapper]="contractorsResponseMapper"
					(selected)="invoiceFilterForm.patchValue({ ourCompany: $event?.id ?? null })"
				></app-generic-mat-autocomplete>
			</div>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Maile</mat-label>
				<input matInput formControlName="mail" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>NIP</mat-label>
				<input matInput formControlName="nip" />
			</mat-form-field>
		</div>

		<div class="row g-3 mt-0">
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Numer fv</mat-label>
				<input matInput formControlName="number" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Waluta</mat-label>
				<input matInput formControlName="currency" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Referencja przewoźnika</mat-label>
				<input matInput type="text" formControlName="carrierReference" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Nawigator ID</mat-label>
				<input type="number" matInput formControlName="navigatorId" />
			</mat-form-field>
		</div>

		<hr class="my-3" />
		<h6 class="mb-2">Status i proces windykacji</h6>
		<div class="row g-3 mt-0">
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Status płatności</mat-label>
				<mat-select formControlName="status">
					<mat-option [value]="null"></mat-option>
					@for (status of statusVindicationFilters; track status.value) {
						<mat-option [value]="status.value">{{ status.label }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Status wewnętrzny</mat-label>
				<mat-select formControlName="internalStatus" multiple>
					@for (status of internalStatusOptions(); track status.id) {
						<mat-option [value]="status.id">{{ status.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Wystawione przez</mat-label>
				<mat-select formControlName="issuedBy">
					<mat-option [value]="null"></mat-option>
					@for (option of issuedByOptions(); track option.id) {
						<mat-option [value]="option.id">{{ option.email }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Mail wysłany</mat-label>
				<mat-select formControlName="mailsSent">
					<mat-option [value]="null"></mat-option>
					<mat-option [value]="true">Tak</mat-option>
					<mat-option [value]="false">Nie</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-3">
				<mat-label>Windykacja automatyczna</mat-label>
				<mat-select formControlName="shouldVindicate">
					<mat-option [value]="null"></mat-option>
					<mat-option [value]="true">Tak</mat-option>
					<mat-option [value]="false">Nie</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<hr class="my-3" />
		<h6 class="mb-2">Kwoty</h6>
		<div class="row g-3 mt-0">
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-2">
				<mat-label>Kwota min</mat-label>
				<input matInput type="number" formControlName="amountMin" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-2">
				<mat-label>Kwota max</mat-label>
				<input matInput type="number" formControlName="amountMax" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-2">
				<mat-label>Kwota z VAT min</mat-label>
				<input matInput type="number" formControlName="amountWithVatMin" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-2">
				<mat-label>Kwota z VAT max</mat-label>
				<input matInput type="number" formControlName="amountWithVatMax" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-2">
				<mat-label>VAT min</mat-label>
				<input matInput type="number" formControlName="vatMin" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="col-12 col-md-6 col-xl-2">
				<mat-label>VAT max</mat-label>
				<input matInput type="number" formControlName="vatMax" />
			</mat-form-field>
		</div>
	</div>

	<div class="row justify-content-end">
		<div class="col-2 d-flex justify-content-end">
			<button class="me-2" mat-raised-button (click)="resetFilters()">Wyczyść</button>
			<button mat-raised-button color="primary" (click)="showInvoiceFilters()">Pokaż</button>
		</div>
	</div>
</form>
